<!-- @format -->
<template>
    <div class="gst-status-chip d-flex align-center px-2 py-1">
        <div
            class="gst-status-chip__circle"
            :style="{ backgroundColor: statusColor }"></div>
        <div class="gst-status-chip__title">{{ statusLabel }}</div>
    </div>
</template>
<script>
import { ORDER_STATUS } from '@tenant/app/utils/constants/orderStatus';

const DEFAULT_STATUS = ORDER_STATUS.PENDING.value;

export default {
    name: 'StatusChip',
    props: {
        status: {
            type: String,
            default: DEFAULT_STATUS,
        },
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBooking.status',
    },
    computed: {
        statusColor() {
            const color = ORDER_STATUS[this.status]?.color || ORDER_STATUS[DEFAULT_STATUS]?.color;

            return this.$vuetify.theme.themes.light[color];
        },
        statusLabel() {
            const label = ORDER_STATUS[this.status]
                ? `${ORDER_STATUS[this.status]?.i18nKeyLabel}`
                : `${ORDER_STATUS[DEFAULT_STATUS]?.i18nKeyLabel}`;

            return this.$t(label);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';

.gst-status-chip {
    width: fit-content;
    border: 1px solid theme-color('senary');
    background-color: theme-color('white');
    border-radius: 1px;
    gap: theme-spacing(1);

    .gst-status-chip__circle {
        height: 10px;
        width: 10px;
        border-radius: border-radius('circle');
    }

    .gst-status-chip__title {
        font-size: font-size('xxs');
        font-weight: font-weight('large');
        letter-spacing: 0.24px;
        text-transform: uppercase;
    }
}
</style>
